import { ACCORDION_INITIAL_ITEMS_COUNT } from '../../../../ahm-constants/ui';
import { FaqItem } from '../../../../types/question';
import { ImageType } from '../../../../types/image';
import { PortableTextType } from '../../../../types/sanityInternal';
import CommonQuestionsSection from '../../../../components/sections/common-questions-section';
import questionsHeroImage from '../../../../images/questions-hero.svg';
import WrappedSection from '../../../../components/sections/wrapped-section';

type CommonQuestionsProps = {
  insuranceType: string;
  items: FaqItem[];
  isTwoColumn: boolean;
  title?: string;
  summary?: PortableTextType[];
  image?: ImageType;
};

const CommonQuestions = ({ insuranceType, isTwoColumn, title, summary, image, items }: CommonQuestionsProps) => {
  const accordionId = `${insuranceType}-insurance-common-questions${isTwoColumn ? '-two-column' : ''}`;
  return (
    <WrappedSection withWide={isTwoColumn} withBorder>
      <CommonQuestionsSection
        accordionId={accordionId}
        questions={items}
        image={
          image || {
            alt: 'Billboard stating "Got questions? We’ve got the answers"',
            src: questionsHeroImage.src,
          }
        }
        title={title || 'Common questions'}
        summary={summary}
        isTwoColumn={isTwoColumn}
        initialVisible={ACCORDION_INITIAL_ITEMS_COUNT}
      />
    </WrappedSection>
  );
};

export default CommonQuestions;
